export enum Templates {
    CLASSIC = "CLASSIC",
    MODERN = "MODERN",
    EXECUTIVE = "EXECUTIVE",
    IMPACT = "IMPACT",
}